import $ from 'jquery';
import { revieveAddToBag } from "../../modules/revieve-try-on";
import init from 'modules/heart-product'

$(function() {
    $('.js-revieve-full-look').on('click', (e) => {
        e.preventDefault();
        Revieve.API.show();
        logEngagement(window.location.href, 'VTO', 'Open');
    });

    revieveAddToBag();

    init('#main-content', '.js-favorite-button');
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/landing/index.js